import React from 'react';
import { PublicWorkSurface } from './PublicWorkSurface';

export default function Block4Capacity() {
  const capabilities = [
    { v: 'EVIDENCIA', d: 'Qué hay (y qué no: missing ≠ negativo).' },
    { v: 'REGLA', d: 'Brecha o hito (regla ≠ hito ≠ tarea).' },
    { v: 'UNA ACCIÓN', d: 'Catálogo de resolución; SYSTEM primero; humano con razón.' },
    { v: 'CUPO', d: 'Antes de contactar. Sin cupo va a WAITING, no se agenda en el aire.' },
    { v: 'EJECUTAR Y ESPERAR', d: 'Si la acción fue tomada, sale de la cola activa y espera resultado.' },
    { v: 'REEVALUAR', d: 'La evidencia nueva genera la siguiente acción. Nunca se cierra la persona.' },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-16 bg-paper border-b border-line overflow-hidden" id="bac-en-accion">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-16 md:mb-20 max-w-4xl px-2">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-4 uppercase tracking-widest">
            BAC en acción
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink leading-[1.2] tracking-tight mb-6">
            El ciclo operacional, no un gestor de tickets.
          </h2>
          <p className="text-[16px] md:text-[18px] text-ink-soft leading-[1.6]">
            La necesidad de un paciente no termina con un examen. BAC transforma la evidencia en una cadena continua de acciones operables.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start max-w-6xl mx-auto w-full">
          <div className="w-full lg:w-[60%] flex flex-col relative px-2">
            <div className="bg-veil p-4 md:p-7 rounded-2xl w-full mx-auto lg:mx-0">
              <PublicWorkSurface className="w-full" />
            </div>
          </div>
          <div className="w-full lg:w-[55%] px-2 pt-8 lg:pt-12">
            <ul className="flex flex-col gap-8 border-l-2 border-brand pl-8">
              {capabilities.map((item, i) => (
                <li key={i} className="flex flex-col gap-1">
                  <div className="text-[14px] font-bold text-ink tracking-widest uppercase">{item.v}</div>
                  <div className="text-[15px] md:text-[16px] text-ink-soft leading-snug">{item.d}</div>
                </li>
              ))}
            </ul>
            <div className="mt-12 pl-8">
              <a href="/bac" className="text-[14px] font-semibold text-brand hover:underline flex items-center gap-1 transition-colors">
                Conocer motores operativos  
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
